interface IProps {
    children: React.ReactNode
}
const SideNavWrapper = ({ children }: IProps) => {
    return (
        <div className='flex-container'>
            {children}
        </div>
    )
}
export default SideNavWrapper